import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class TipoRtrValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        if (refs.idtiportrerpInput.required && !model.idtiportrerp) {
            validated = false;
            refs.idtiportrerpInput.focusedOut = true;
            this.showMessage(new Message("alert", "msg-campos-obrigatorios", true));
        }
        
        if (!model.descricao) {
            validated = false;
            refs.descricaoInput.focusedOut = true;
            this.showMessage(new Message("alert", "msg-campos-obrigatorios", true));
        }

        

        return validated;
    }

}